export default __webpack_public_path__ + "static/media/pantheon_symetry.7b23cda4.jpg";